module.exports = __webpack_public_path__ + "static/img/jc_zt_sec3_img4.6e5d9af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceThree/jc_zt_sec3_img4.jpg
// module id = 8fdx
// module chunks = 171